const NAME = 'ORG_COMMENT_EDIT';

export const CHANGE_COMMENT = `${NAME}/CHANGE_COMMENT`;
export const REQUEST_UPDATE_COMMENT = `${NAME}/REQUEST_UPDATE_COMMENT`;
export const COMMENT_UPDATE_COMPLETED = `${NAME}/COMMENT_UPDATE_COMPLETED`;
export const COMMENT_UPDATE_FAILED = `${NAME}/COMMENT_UPDATE_FAILED`;
export const COMMENT_UPDATE_RESET = `${NAME}/COMMENT_UPDATE_RESET`;
